import { useMemo } from 'react';
import { useDepartments } from '@/shared/hooks/useDepartments';
import { DEPT_LABELS as FALLBACK_LABELS, DEPT_OPTIONS as FALLBACK_OPTIONS, deptSlug } from '../constants';

/**
 * Department choices for announcements, from the organisation's own departments (the API
 * stores a slug: 'Digital Marketing' -> 'digital_marketing'). Falls back to the built-in
 * list until the departments load, so the form is never empty.
 */
export function useAnnouncementDepartments() {
  const { data: departments } = useDepartments();
  return useMemo(() => {
    if (!departments || departments.length === 0) return { options: FALLBACK_OPTIONS, labels: FALLBACK_LABELS };
    const options = [
      { value: 'all', label: 'All Departments' },
      ...departments.map((d) => ({ value: deptSlug(d.name), label: d.name })),
    ];
    // Keep labels for slugs of departments that were renamed or removed since an announcement was posted.
    return { options, labels: { ...FALLBACK_LABELS, ...Object.fromEntries(options.map((o) => [o.value, o.label])) } };
  }, [departments]);
}
